import React, { useState } from 'react';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent! We will get back to you soon.');
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <section className="contact" id="venue">
      <div className="container">
        <div className="contact__grid">
          <div>
            <h2 className="contact__title">We Are Here To Connect And Assist You</h2>
            <p className="contact__desc">
              Have questions about LLC 2026? Need help with registration, partnerships,
              or logistics? The LinkedIn Local Cameroon organising team is ready to help.
            </p>
            <div className="contact__info-grid">
              <div>
                <div className="contact__info-label">CONTACT US</div>
                <div className="contact__info-val">@LinkedInLocalCameroon</div>
              </div>
              <div>
                <div className="contact__info-label">EVENT LOCATION</div>
                <div className="contact__info-val">
                  Best Western Plus Hotel,<br />
                  <span style={{ color: '#FFB400', fontWeight: 700 }}>Soaho Douala Airport</span>
                </div>
              </div>
              <div>
                <div className="contact__info-label">EMAIL</div>
                <div className="contact__info-val">official@linkedinlocalcameroon.com</div>
              </div>
              <div>
                <div className="contact__info-label">FOLLOW US</div>
                <div className="contact__social">
                  {['f', 'in', 'ig', 'yt'].map((s) => (
                    <a key={s} href="#!" className="contact__social-icon">{s}</a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="form-card">
            <div className="form-card__title">GET IN TOUCH</div>
            <div className="form-card__desc">
              Reach out with inquiries about tickets, partnerships, or event details.
            </div>
            <form onSubmit={handleSubmit}>
              <input
                className="form-input"
                name="name"
                placeholder="Name"
                value={form.name}
                onChange={handleChange}
                required
              />
              <input
                className="form-input"
                name="email"
                type="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                required
              />
              <input
                className="form-input"
                name="subject"
                placeholder="Subject"
                value={form.subject}
                onChange={handleChange}
              />
              <textarea
                className="form-textarea"
                name="message"
                placeholder="Message"
                value={form.message}
                onChange={handleChange}
                rows={3}
              />
              <button type="submit" className="btn-send">Send message</button>
            </form>
          </div>
        </div>

        <div className="map-card">
          <div className="map-placeholder">
            <div className="map-grid" />
            <div className="map-pin" />
          </div>
        </div>
      </div>
    </section>
  );
}
